import { style } from 'typestyle'
import { important } from 'csx'
export const f20i = style({ fontSize: important('20px') })
